import { styled } from '@mui/material/styles'
import { colors } from '@resiliatech/birdsong'
import { useLocation } from 'react-router'
import { useMediaQuery } from '@mui/material'
import { SkeletonLoader } from '../SkeletonLoader/SkeletonLoader'

export const SuperLoading = ({ withSidebar }: { withSidebar?: boolean }) => {
  const isSmallScreen = useMediaQuery('@media (max-width:959.95px)')
  const { pathname } = useLocation()
  const isPageWithoutSidebar =
    pathname.includes('account/donation/portal') ||
    pathname.includes('impact/stories/view') ||
    pathname.includes('impact/stories/edit') ||
    pathname === '/fundraising/funder'

  return (
    <Container data-testid='super-loading'>
      {withSidebar && !isPageWithoutSidebar && (
        <Sidebar>
          <TopSkeleton>
            <SkeletonLoader
              shimmerWidth='300%'
              styles={{
                backgroundColor: '#003F7E',
                backgroundImage:
                  'linear-gradient(90deg, #003F7E, #00264C 20%, #00203F 50%, #00264C 80%, #003F7E)',
              }}
            />
          </TopSkeleton>
          <BottomSkeleton>
            <SkeletonLoader
              shimmerWidth='300%'
              styles={{
                backgroundColor: '#003F7E',
                backgroundImage:
                  'linear-gradient(90deg, #003F7E, #00264C 33%, #00203F 66%, #003F7E)',
              }}
            />
          </BottomSkeleton>
        </Sidebar>
      )}
      <Content mainLoader={!!withSidebar}>
        {!isSmallScreen && (
          <LoadingTitle>
            <SkeletonLoader />
          </LoadingTitle>
        )}
        <LoadingContainer>
          <SkeletonLoader />
        </LoadingContainer>
      </Content>
    </Container>
  )
}

const LoadingTitle = styled('div')`
  height: 40px;
  width: 288px;
`

const LoadingContainer = styled('div')`
  height: 200px;
  width: 100%;
  margin-top: 20px;
`

const Sidebar = styled('div')`
  height: 100%;
  width: 240px;
  background: ${colors.feedback.infoDark};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media screen and (max-width: 960px) {
    width: 100%;
    height: 62px;
    flex-direction: row;
  }
`

const TopSkeleton = styled('div')`
  width: 200px;
  height: 352px;
  margin: 24px auto;
  @media screen and (max-width: 960px) {
    width: 100%;
    height: 24px;
    margin: 16px;
    flex-direction: row;
  }
`

const BottomSkeleton = styled('div')`
  width: 200px;
  height: 18px;
  margin: 24px auto;
  @media screen and (max-width: 960px) {
    display: none;
  }
`

const Content = styled('div')<{ mainLoader: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  margin: ${(mainLoader) => (mainLoader ? '40px' : '14px 40px 40px 40px')};
`

const Container = styled('div')`
  color: ${colors.interactive.disabledDark};
  font-family: 'Source Sans Pro';
  font-size: 20px;
  display: flex;
  height: 100vh;
  width: 100%;
  background: ${colors.background.primaryBackground};
  p,
  span {
    text-align: center;
    margin: 0 auto;
  }
  span {
    margin-top: 12px;
  }

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
`
